var getDestinationUrl = function getDestinationUrl(args) {
  var landingUrl = args.landingUrl,
    query = args.query;
  return "".concat(landingUrl, "?swsquery=").concat(query, "&querycat=search_dropdown");
};

export { getDestinationUrl };
//# sourceMappingURL=destinationUrlBuilder.js.map
